import { fetch } from '../utils/fetch';

/**
 * 查询列表
 * @returns {Promise<Response>}
 */
export function _queryIndexPosters(
  {
    page, size, direction, sort,
  },
) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/index-images`,
    method: 'get',
    params: {
      page,
      size,
      direction,
      sort,
    },
  });
}

/**
 * 根据 id 查询
 * @returns {Promise<Response>}
 */
export function _queryIndexPoster(indexPosterId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/index-images/${indexPosterId}`,
    method: 'get',
  });
}

/**
 * 新增
 * @param  title
 * @param  subTitle
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _addIndexPoster(
  {
    title,
    subTitle,
    imgPath,
  },
) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/index-images`,
    method: 'post',
    data: {
      title,
      subTitle,
      imgPath,
    },
  });
}

/**
 * 更新
 * @param indexPosterId
 * @param  title
 * @param  subTitle
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _updateIndexPoster(indexPosterId, {
  title,
  subTitle,
  imgPath,
}) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/index-images/${indexPosterId}`,
    method: 'patch',
    data: {
      title,
      subTitle,
      imgPath,
    },
  });
}

/**
 * 删除
 * @param indexPosterId
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _deleteIndexPoster(indexPosterId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/index-images/${indexPosterId}`,
    method: 'delete',
  });
}

/**
 * 上移
 * @param indexPosterId
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _upIndexPoster(indexPosterId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/index-images/${indexPosterId}/up`,
    method: 'patch',
  });
}

/**
 * 下移
 * @param indexPosterId
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _downIndexPoster(indexPosterId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/index-images/${indexPosterId}/down`,
    method: 'patch',
  });
}

export default {};
